module.exports = __webpack_public_path__ + "static/media/icon_modulo_hover.3254610d.svg";